import axios from 'axios';
import { useEffect, useState } from 'react';
import styled from 'styled-components';

type Props = {
  src: string;
  onLoad: () => void;
  [x: string]: any;
};

const InlineSvg = ({ src, onLoad, ...rest }: Props) => {
  // React Hooks
  const [svg, setSvg] = useState('');

  useEffect(() => {
    axios(src).then((res) => setSvg(res.data));
  }, [src]);

  useEffect(() => {
    if (svg) {
      onLoad();
    }
    // eslint-disable-next-line
  }, [svg]);

  return <StyledSvgWrapper {...rest} dangerouslySetInnerHTML={{ __html: svg }} />;
};

export default InlineSvg;

const StyledSvgWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`;
